export default __webpack_public_path__ + "static/media/combot-grey.ae0a884e.svg";